<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <contributions-list>
        </contributions-list>
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import contributionsList from './todo-contributions-list'
export default {
    components: {
        contributionsList
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/base-contributions-list.vue